<div class="w-full flex flex-col" [ngClass]="containerCss()">
  <div class="flex w-full items-center flex-row py-2">
    @if (hasMultipleMessages()) {
      <button
        mat-icon-button
        class="rotate-180 !h-6 !w-6 !flex items-center justify-center !overflow-hidden"
        [ngClass]="actionButtonsCss()"
        [disabled]="manualChangeSub()"
        (click)="goToPreviusMessage()">
        <mat-icon svgIcon="chevron"></mat-icon>
      </button>
    }
    <div class="grow pl-3 pr-2 overflow-hidden">
      <div
        [@fadeAnimation]="{
          value: messageVisibility(),
          params: {
            fadeOutDuration: parsedFadeOutDuration(),
            fadeInDuration: parsedFadeInDuration(),
          },
        }"
        class="w-fit min-h-6"
        [ngClass]="contentCss()">
        {{ currentMessage() }}
      </div>
    </div>
    @if (hasMultipleMessages()) {
      <button
        mat-icon-button
        class="!h-6 !w-6 !flex items-center justify-center !overflow-hidden"
        [ngClass]="actionButtonsCss()"
        [disabled]="manualChangeSub()"
        (click)="goToNextMessage()">
        <mat-icon svgIcon="chevron"></mat-icon>
      </button>
    }
  </div>
  @if (hasMultipleMessages()) {
    <div>
      <div
        class="grid absolute w-full"
        [style.grid-template-columns]="
          'repeat(' + messages().length + ', 1fr)'
        ">
        @for (msg of messages(); track msg) {
          <div
            class="border-l border-r h-1"
            [class.!border-l-0]="$first"
            [class.!border-r-0]="$last"
            [ngClass]="progressSeparatorsCss()"></div>
        }
      </div>
      <edt-progress-bar
        height="4px"
        [value]="progressPorcent()"
        [style.--transition-duration]="progressTransitionDuration() + 'ms'"
        [barClasses]="barCss()"
        [progressClasses]="
          progressCss() + ' transition-[width] ease-linear transition-duration'
        ">
      </edt-progress-bar>
    </div>
  }
</div>
